module.exports = __webpack_public_path__ + "12a8b0634f0b1c1231b95370d8f0cc2e.pdf";